import { makeStyles, tokens } from "@fluentui/react-components";
export const useStyles = makeStyles({
    /** Styles applied to the root of the component */ root: {
        borderRadius: tokens.borderRadiusXLarge,
        whiteSpace: "nowrap",
        fontWeight: tokens.fontWeightRegular,
        ":hover": {
            color: tokens.colorBrandForeground1,
            "& svg": {
                color: tokens.colorBrandForeground1
            }
        }
    },
    /** Styles applied when the button is in icon-only mode */ iconOnly: {
        border: "none"
    }
});
